import { getCurrentEnterpriseId } from '@mews-commander/core';
import { CommanderThunkAction } from '@mews-commander/types';
import { loadScript } from '@mews/framework';
import { getPciProxyScriptUrl } from './modules/app/reducers/configuration';

export const initPciProxyScript =
    (): CommanderThunkAction =>
    async (dispatch, getState, { loggerService }) =>
        loadScript(getPciProxyScriptUrl()).catch((error) => {
            loggerService.log('script-load-error', 'PciProxy javascript could not be loaded.', {
                error,
                enterpriseId: getCurrentEnterpriseId(),
            });

            throw error;
        });
